import { ResultWells, Well } from 'src/app/interfaces/well';

export const WELLS: Well[] = [
  {
    wellId: '5400005746',
    uwi: '5400005746',
    wellCommonName: 'PB-900',
    wellLegalName: 'PAE.SC.B-900',
    locCountry: 'ARGENTINA',
    locState: 'SANTA CRUZ',
    project: 'BAYO',
    districtName: 'Cinco',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: true,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400002971',
    uwi: '5400002971',
    wellCommonName: 'PVH-1323',
    wellLegalName: 'PAE.Ch.VH-1323',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'VALLE HERMOSO',
    districtName: 'Dos',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005664',
    uwi: '5400005664',
    wellCommonName: 'PAF-148',
    wellLegalName: 'PAE.Ch.AF-148',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'ANTICLINAL FUNES',
    districtName: 'Cinco',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005355',
    uwi: '5400005355',
    wellCommonName: 'PZ-1473',
    wellLegalName: 'PAE.Ch.Z-1473',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'ZORRO',
    districtName: 'Tres',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400004469',
    uwi: '5400004469',
    wellCommonName: 'PCD-1053',
    wellLegalName: 'PAE.Ch.CD-1053',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'CERRO DRAGÓN',
    districtName: 'Uno',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005609',
    uwi: '5400005609',
    wellCommonName: 'PCD-1181(d)',
    wellLegalName: 'PAE.Ch.CD-1181(d)',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'CERRO DRAGÓN',
    districtName: 'Uno',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005984',
    uwi: '5400005984',
    wellCommonName: 'PCD-1290',
    wellLegalName: 'PAE.Ch.CD-1290',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'CERRO DRAGÓN',
    districtName: 'Uno',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400006173',
    uwi: '5400006173',
    wellCommonName: 'PCD-1304(d)',
    wellLegalName: 'PAE.Ch.CD-1304(d)',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'CERRO DRAGÓN',
    districtName: 'Uno',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005950',
    uwi: '5400005950',
    wellCommonName: 'PEC-807',
    wellLegalName: 'PAE.Ch.EC-807',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'EL CONDOR',
    districtName: 'Uno',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005414',
    uwi: '5400005414',
    wellCommonName: 'BCeCf-127(h)',
    wellLegalName: 'PAE.Nq.BCeCf-127(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'BANDURRIA CENTRO',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005416',
    uwi: '5400005416',
    wellCommonName: 'BCeAg-130(h)',
    wellLegalName: 'PAE.Nq.BCeAg-130(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'BANDURRIA CENTRO',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005759',
    uwi: '5400005759',
    wellCommonName: 'BCeCh-135(h)',
    wellLegalName: 'PAE.Nq.BCeCh-135(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'BANDURRIA CENTRO',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005530',
    uwi: '5400005530',
    wellCommonName: 'ACas-101(h)',
    wellLegalName: 'PAE.Nq.ACas-101(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'AGUADA DE CASTRO',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400004724',
    uwi: '5400004724',
    wellCommonName: 'PLMS-954',
    wellLegalName: 'PAE.Ch.LMS-954',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'LA MADRESELVA SUR',
    districtName: 'Ocho',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005470',
    uwi: '5400005470',
    wellCommonName: 'PAG-987',
    wellLegalName: 'PAE.Ch.AG-987',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'ANTICLINAL GRANDE',
    districtName: 'Cinco',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400006069',
    uwi: '5400006069',
    wellCommonName: 'PAG-1000',
    wellLegalName: 'PAE.Ch.AG-1000',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'ANTICLINAL GRANDE',
    districtName: 'Cinco',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005533',
    uwi: '5400005533',
    wellCommonName: 'ECh.x-101(h)',
    wellLegalName: 'PAE.Nq.ECh.x-101(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'LINDERO ATRAVESADO OCCIDENTAL',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005265',
    uwi: '5400005265',
    wellCommonName: 'ECh-102(h)',
    wellLegalName: 'PAE.Nq.ECh-102(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'LINDERO ATRAVESADO OCCIDENTAL',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005895',
    uwi: '5400005895',
    wellCommonName: 'PJ-823',
    wellLegalName: 'PAE.Ch.J-823',
    locState: 'CHUBUT',
    locCountry: 'ARGENTINA',
    project: 'JORGE',
    districtName: 'Ocho',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005953',
    uwi: '5400005953',
    wellCommonName: 'PMCCh.x-1001',
    wellLegalName: 'PAE.SC.MCCh.x-1001',
    locState: 'SANTA CRUZ',
    locCountry: 'ARGENTINA',
    project: 'MESETA CERON CHICO',
    districtName: 'Nueve',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400004891',
    uwi: '5400004891',
    wellCommonName: 'KK-1320',
    wellLegalName: 'PAE.SC.KK-1320',
    locState: 'SANTA CRUZ',
    locCountry: 'ARGENTINA',
    project: 'KOLUEL KAIKE',
    districtName: 'Cuatro',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400004892',
    uwi: '5400004892',
    wellCommonName: 'KK-1325',
    wellLegalName: 'PAE.SC.KK-1325',
    locState: 'SANTA CRUZ',
    locCountry: 'ARGENTINA',
    project: 'KOLUEL KAIKE',
    districtName: 'Cuatro',
    ug: 'GSJ',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005457',
    uwi: '5400005457',
    wellCommonName: 'APO.x-101(h)',
    wellLegalName: 'PAE.Nq.APO.x-101(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'AGUADA PICHANA OESTE',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
  {
    wellId: '5400005927',
    uwi: '5400005927',
    wellCommonName: 'APO-204(h)',
    wellLegalName: 'PAE.Nq.APO-204(h)',
    locState: 'NEUQUÉN',
    locCountry: 'ARGENTINA',
    project: 'AGUADA PICHANA OESTE',
    districtName: 'Sin Distrito',
    ug: 'NQN',
    northing: 4892682.01,
    easting: 2497736,
    groundElevation: 380.7,
    datum: 'KELLY BUSHING / ROTARY TABLE',
    datumElevation: 385.57,
    airGap: 4.87,
    haveHistoricalHandovers: false,
    existHogAccepted: false,
    existHo1Accepted: false,
    existHoecAccepted: false,
    existHoloc0Accepted: false,
    lastHoloc0AcceptedDate: new Date('2024-06-11T00:00:00'),
    existHogLocAccepted: false,
    pemDate: new Date('2024-06-11T00:00:00'),
    abandonmentDate: new Date('2025-06-11T00:00:00'),
    drillingDate: new Date('2024-08-11T00:00:00'),
    depth: 1300,
    waterInjection: 10.5,
    water: 1000,
    gas: 10000,
    oil: 50000,
  },
];

export const RESULT_WELLS: ResultWells = {
  wells: WELLS,
  totalWells: 24,
};
